import { ChangeDetectorRef, Component } from '@angular/core';
import { ProductListComponentService, ProductScrollComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-scroll',
  templateUrl: './product-ekscroll.component.html',
  styleUrls: ['./product-ekscroll.component.scss']
})
export class ProductEkscrollComponent extends ProductScrollComponent {

  constructor(productListComponentService: ProductListComponentService, ref: ChangeDetectorRef) {
    super(productListComponentService, ref);
  }



}
